// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 130) return "static/chunks/130.d18cd52eb743e676.js";
	if (chunkId === 281) return "static/chunks/281.5030f86ae2d0c911.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"225":"57671f315ae3f6d7","374":"1ac790fafa1ec401","812":"14bc97d1c30cd567","917":"2db0521d3959428a","939":"163c022470a9e51a","975":"62ec7aa067157e0c"}[chunkId] + ".js";
};